import { createFileRoute, useSearch } from '@tanstack/react-router';
import { PileCableForm } from '@amber-ui/core';

function PileCableRoute() {
  const { pile, cable } = useSearch({ strict: false }) as {
    pile?: string;
    cable?: string;
  };
  const pile_id = pile || null;

  if (!pile_id) return null;

  return <PileCableForm pile_id={pile_id} cable_id={cable || undefined} />;
}

export const Route = createFileRoute('/_auth/_pile/pile/cable')({
  component: PileCableRoute,
});
